import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { supabase } from '../lib/supabase';
import Avatar from '../components/Avatar';

export default function Home() {

  return (
    <div>
      <button onClick={() => alert('Tu es dispo !')}>📅 Je suis dispo</button>
      <button onClick={() => alert('Liste des gens dispos')}>👀 Qui est dispo ?</button>
    </div>
  );
}
